module.exports = __webpack_public_path__ + "static/total-costs-b501f81ed873c7b62d5ef1181da33df7.png";